<template>
  <div id="index">
    <div style="justify-content: center; margin-top:60px;" class="imgBg">
      <div style="text-align: center">
        <img src="../../../assets/noPermission.png" width="200"/>
        <div style="font-size: 48px;color: #C73343;font-weight: bold">Sorry</div>
        <div style="color: #C73343;margin-top: 10px;font-size: 26px;">您暂无权限访问该页面...</div>
        <div style="color: #C73343;margin-top: 10px;font-size: 26px;">You have no access to this page.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () { // 所有的数据都写在里面
    return {
    }
  },
  created () {
  },
  methods: {// 所有的方法写在里面
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/login/noPermission.vue